import styles from "./downBtn.module.scss";
import Link from "next/link";

export default function DownBtn(props) {
  const icon = () => {
    if (props.use === "big") {
      return {
        ios: "/img/googleplay-b.png",
        google: "/img/appstore-b.png",
      };
    } else {
      return {
        ios: "/img/googleplay-s.png",
        google: "/img/appstore-s.png",
      };
    }
  };
  return (
    <div className={styles.down + " " + (props.ani ? " ani-fadeInUp" : "")}>
      <Link href="https://itunes.apple.com/app/dingtone-free-phone-calls/id588937297?mt=8">
        <a>
          <img src={icon().google} alt="googleplay" />
        </a>
      </Link>
      <Link href="https://play.google.com/store/apps/details?id=me.dingtone.app.im">
        <a>
          <img src={icon().ios} alt="appstore" />
        </a>
      </Link>
    </div>
  );
}
